import PropTypes from 'prop-types';
import { useEffect } from 'react';

export default function Select({
	filteredTaxonomies,
	getLabel,
	handleFilterChange,
	handleFilterClear,
	isOpen,
	isOptionDisabled,
	setExpandedSelect,
	taxonomy,
	taxonomyName,
}) {
	const selectControlClass = 'jobs__control--select';

	useEffect(() => {
		window.addEventListener('click', (e) => {
			if (!e.target.closest(`.${selectControlClass}`)) {
				setExpandedSelect(false);
			}
		});
	}, []);

	const placeholder = getLabel(`placeholder_${taxonomyName}`);

	const handleClearClick = (e, taxonomyName) => {
		e.stopPropagation();
		handleFilterClear(taxonomyName);
	};

	const getHeadline = () =>
		taxonomyName in filteredTaxonomies ? Object.values(taxonomy.terms).find((option) => option.slug === filteredTaxonomies[taxonomyName])?.name : placeholder;

	return (
		<div className={`jobs__control ${selectControlClass}`}>
			<label>{taxonomy.singular_name}</label>
			<div className={isOpen ? 'open' : 'closed'} onClick={() => setExpandedSelect(isOpen ? false : taxonomyName)}>
				<span className="value">{getHeadline()}</span>

				<div className="controls">
					{filteredTaxonomies[taxonomyName] && (
						<span className="clear" title={getLabel('clear_filter')} onClick={(e) => handleClearClick(e, taxonomyName)}></span>
					)}
					<span className="arrow"></span>
				</div>

				{isOpen && (
					<div className="options">
						<div key="default" data-value="0" data-disabled={false} onClick={() => handleFilterChange(taxonomyName, '0', false)}>
							{placeholder}
						</div>
						{Object.values(taxonomy.terms).map((option) => (
							<div
								key={option.id}
								data-value={option.slug}
								data-disabled={isOptionDisabled(taxonomyName, option)}
								onClick={() => handleFilterChange(taxonomyName, option.slug, isOptionDisabled(taxonomyName, option))}
							>
								{option.name}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
}

Select.propTypes = {
	filteredTaxonomies: PropTypes.object,
	getLabel: PropTypes.func,
	handleFilterChange: PropTypes.func,
	handleFilterClear: PropTypes.func,
	isOpen: PropTypes.bool,
	isOptionDisabled: PropTypes.func,
	setExpandedSelect: PropTypes.func,
	taxonomy: PropTypes.object,
	taxonomyName: PropTypes.string,
};
